import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { green } from "@mui/material/colors";
import Filter3Icon from "@mui/icons-material/Filter3";

const HypervisedSpent = (props) => {
  const [labscard, setLabscard] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/billingview/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setLabscard(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <Card
      sx={{ height: "100%", border: 1, borderColor: "text.primary" }}
      {...props}
    >
      <CardContent>
        <Grid container spacing={3} sx={{ justifyContent: "space-between" }}>
          <Grid item>
            <Typography
              style={{ textAlign: "center" }}
              variant="h6"
              gutterBottom
              component="div"
            >
              HYPERVISED
            </Typography>
            <Typography color="textSecondary" gutterBottom variant="h6">
              SPENT:
            </Typography>
            <Typography color="textPrimary" variant="h3">
              {`${labscard.hvm}`}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: green[600],
                height: 56,
                width: 56,
              }}
            >
              <Filter3Icon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default HypervisedSpent;
